import { Component } from "@angular/core";
import { MatDialogRef }      from "@angular/material/dialog";
import { Iso639_1 } from "../../../_model/Language";
import { PHBGlobals } from "../../../_config/config";
import { MatButtonModule } from "@angular/material/button";
import { TranslatePipe } from "../../pipes/translate";

@Component({
	selector: "app-version-changed",
	templateUrl: "./version-changed.component.html",
	styleUrls: ["./version-changed.component.scss"],
	standalone: true,
	imports: [
		MatButtonModule,
		TranslatePipe
	]
})
export class VersionChangedComponent {

	get systemLanguage(): Iso639_1 {
		return PHBGlobals.systemLanguage;
	}


	constructor(protected dialogRef: MatDialogRef<VersionChangedComponent>) {
	}

	acceptAndClose() {
		location.reload();
		this.close();
	}

	close() {
		this.dialogRef.close();
	}

}
